<template>
  <div v-bind:class="{rectAd: true, pc:eq==2}">
    <div v-if="type==0">
      <a href="https://bit.ly/pitacoin">
        <img src="../../assets/banner_pitacoin.png" alt="">
      </a>
    </div>
    <div v-if="type==1">
      <a href="https://px.a8.net/svt/ejp?a8mat=2ZW185+419TXE+3CWI+BZGEP" target="_blank" rel="nofollow">
      <img border="0" width="300" alt="" src="https://www24.a8.net/svt/bgt?aid=181213493244&wid=003&eno=01&mid=s00000015669002013000&mc=1"></a>
      <img border="0" width="1" height="1" src="https://www14.a8.net/0.gif?a8mat=2ZW185+419TXE+3CWI+BZGEP" alt="">
    </div>
    <div v-if="type==2">
        <a href="https://h.accesstrade.net/sp/cc?rk=0100kzh200iumu" rel="nofollow" target="_blank"><img src="https://h.accesstrade.net/sp/rr?rk=0100kzh200iumu" alt="U-NEXT" border="0" /></a>
    </div>
    <div v-if="type==3">
      <a href="https://px.a8.net/svt/ejp?a8mat=2TTNNK+CGWWG2+3VI8+63WO1" target="_blank" rel="nofollow">
      <img border="0" width="300" alt="" src="https://www28.a8.net/svt/bgt?aid=171024896754&wid=003&eno=01&mid=s00000018080001026000&mc=1"></a>
      <img border="0" width="1" height="1" src="https://www15.a8.net/0.gif?a8mat=2TTNNK+CGWWG2+3VI8+63WO1" alt="">
    </div>
    <div v-if="type==4">
      <a href="https://px.a8.net/svt/ejp?a8mat=2ZW185+BJKMKI+3ZZC+5ZU29" target="_blank" rel="nofollow">
      <img border="0" width="300" alt="" src="https://www24.a8.net/svt/bgt?aid=181213493698&wid=003&eno=01&mid=s00000018660001007000&mc=1"></a>
      <img border="0" width="1" height="1" src="https://www19.a8.net/0.gif?a8mat=2ZW185+BJKMKI+3ZZC+5ZU29" alt="">
    </div>
    <div v-if="type==5">
      <a href="https://px.a8.net/svt/ejp?a8mat=2TMXND+42GP4Y+37HI+601S1" target="_blank" rel="nofollow">
      <img border="0" width="300" alt="" src="https://www23.a8.net/svt/bgt?aid=170711257246&wid=003&eno=01&mid=s00000014967001008000&mc=1"></a>
      <img border="0" width="1" height="1" src="https://www13.a8.net/0.gif?a8mat=2TMXND+42GP4Y+37HI+601S1" alt="">
    </div>
    <div v-if="type==6">
      <a href="https://px.a8.net/svt/ejp?a8mat=2TTNNK+CQFU4I+3UOI+609HT" target="_blank" rel="nofollow">
      <img border="0" width="300" alt="" src="https://www23.a8.net/svt/bgt?aid=171024896770&wid=003&eno=01&mid=s00000017973001009000&mc=1"></a>
      <img border="0" width="1" height="1" src="https://www10.a8.net/0.gif?a8mat=2TTNNK+CQFU4I+3UOI+609HT" alt="">
    </div>
    <div v-if="type==7">
      <a href="https://px.a8.net/svt/ejp?a8mat=2ZW186+BA1OW2+1LP8+CD68H" target="_blank" rel="nofollow">
      <img border="0" width="300" alt="" src="https://www26.a8.net/svt/bgt?aid=181213494682&wid=003&eno=01&mid=s00000007478002077000&mc=1"></a>
      <img border="0" width="1" height="1" src="https://www11.a8.net/0.gif?a8mat=2ZW186+BA1OW2+1LP8+CD68H" alt="">
    </div>
    <div v-if="type==8">
      <a href="https://px.a8.net/svt/ejp?a8mat=2ZW185+CIP79E+1JS2+CH14H" target="_blank" rel="nofollow">
      <img border="0" width="300" alt="" src="https://www21.a8.net/svt/bgt?aid=181213493757&wid=003&eno=01&mid=s00000007229002095000&mc=1"></a>
      <img border="0" width="1" height="1" src="https://www11.a8.net/0.gif?a8mat=2ZW185+CIP79E+1JS2+CH14H" alt="">
    </div>
  </div>
</template>

<script>
export default {
  name: 'Ad1',
  props: ['eq'],
  components: {
  },
  data () {
    return {
      type: 1
    }
  },
  created () {
    this.type = Math.floor(Math.random() * 9)
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .rectAd{
    display: inline-block;
  }
  .rectAd > div{
    display: inline-block;
  }
  @media all and (max-width: 480px) {
    .pc{
      display: none;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/ad/RectAd.vue